import React, { FunctionComponent } from "react";

import {
  Stack,
  SvgIcon,
  SvgIconProps,
  Typography,
  TypographyProps,
} from "@mui/material";

import ModuleIcon from "./ModuleIcon";

interface ModuleTitleProps extends TypographyProps {
  icon?: typeof SvgIcon | FunctionComponent<SvgIconProps>;
}

const ModuleTitle = ({ sx, icon: Icon, ...props }: ModuleTitleProps) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {Icon && (
        <ModuleIcon>
          <Icon
            sx={{ color: "shades.primary.500", height: "18px", width: "18px" }}
          />
        </ModuleIcon>
      )}
      <Typography
        variant="bodyPrimaryMed"
        sx={{
          color: "shades.neutral.700",
          fontWeight: 600,
          ...sx,
        }}
        {...props}
      />
    </Stack>
  );
};

export default ModuleTitle;
